import { useDisclosure } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { HEADER_ID, PageLayout } from '@/components/templates/PageLayout';
import {
  CmButton,
  CmDeleteConfirmModal,
  CmFlex,
  CmLongLoading,
  CmScrollBox,
  CmSeparate,
  CmStack,
} from '@/components/uiParts';
import { CmBackLink } from '@/components/uiParts/Link/CmBackLink ';
import { useTargetsDomHeight } from '@/hooks/Dom';
import { redirect404Page } from '@/lib/AccessControl';
import { TempHourForm } from '@/pages/camel-order/temp-hour/components/TempHourForm';
import { useTempHourForm } from '@/pages/camel-order/temp-hour/hooks/useTempHoursForm';
import { routes } from '@/router';
import { useManagerAccountMe } from '@/services/AuthEnterprise/hooks';

export const BREAD_CRUMB_AREA_ID = 'bread-crumb-area';

const TempHoursEditPage: React.FC = (): JSX.Element => {
  // /* アクセス制御 */
  const history = useHistory();
  const { managerAccountMe } = useManagerAccountMe();
  redirect404Page('camel_order_site_setting', history, managerAccountMe);

  const {
    isOpen: isOpenDeleteConfirmModal,
    onOpen: openDeleteConfirmModal,
    onClose: onCloseDeleteConfirmModal,
  } = useDisclosure();
  const { id: urlParamsId } = useParams<{ id: string }>();
  const { targetsHeight } = useTargetsDomHeight([
    HEADER_ID,
    BREAD_CRUMB_AREA_ID,
  ]);

  const {
    isLoading,
    initialize,
    handleUpdate,
    handleDelete,
    selectedSiteId,
    isDisabledSubmit,
    listUrl,
    ...formProps
  } = useTempHourForm(urlParamsId);

  useEffect(() => {
    (async () => {
      initialize();
    })();
  }, []);

  return (
    <PageLayout title={routes.tempHourEdit.title}>
      <CmStack
        direction="row"
        mt="25px"
        id={BREAD_CRUMB_AREA_ID}
        justifyContent="space-between"
        alignItems="center"
      >
        <CmBackLink to={listUrl}>一覧へ戻る</CmBackLink>
        <CmFlex alignItems="center">
          {/*
           // @ts-ignore TS2590 */}
          <CmButton isDisabled={isDisabledSubmit} onClick={handleUpdate}>
            更新
          </CmButton>
          <CmSeparate mx="30px" />
          <CmButton colorScheme="red" onClick={openDeleteConfirmModal}>
            削除
          </CmButton>
        </CmFlex>
      </CmStack>
      <CmScrollBox>
        <TempHourForm
          {...formProps}
          selectedSiteId={selectedSiteId}
          height={`calc(100vh - ${targetsHeight}px - 80px)`}
        />
      </CmScrollBox>
      {isLoading && <CmLongLoading />}
      <CmDeleteConfirmModal
        name="休業日・臨時営業時間"
        handleClick={handleDelete}
        isOpen={isOpenDeleteConfirmModal}
        onClose={onCloseDeleteConfirmModal}
      />
    </PageLayout>
  );
};

export default TempHoursEditPage;
